export default name => {
  if (!localStorage.getItem(name)) return true

  return localStorage.getItem(name) === 'yes'
}
